import axios from 'axios'
import store from '@/store'
import { Message } from 'element-ui'
import matchWhitelist from '@/router-v2/whitelist'
import { getStorage } from './storage'
import { systemInfo } from "@/shared-services";

const service = axios.create({
  baseURL: process.env.VUE_APP_URL,
  timeout: 100000
})
const isPre = process.env.VUE_APP_BUILD_ENV === 'pre';

service.interceptors.request.use(
  config => {
    if(config.url.indexOf("zuul/") !== -1) {
      config.headers['system-source'] = systemInfo.isCommand ? "fleet" : "dispatcher";
    }
    if(isPre && config.url) {
      if(config.url.startsWith('/command-center/')) {
        config.url = config.url.replace('/command-center/', '/command-center-pre/')
      }
    }


    if (config.headers['disable-token']) {
      delete config.headers['disable-token']
    } else if (config.headers['tp-interface']) {
      delete config.headers['tp-interface']
      config.headers['x-auth-token'] = process.env.VUE_APP_TOKEN
      config.headers['client'] = process.env.VUE_APP_CLIENT
      config.headers['Installation-ID'] = process.env.VUE_APP_INSTALLATION_ID
    } else if (typeof config.headers['portal-token'] !== 'string') {
      if (getStorage('x-portal-token') === 'yes') {
        delete config.headers['portal-token']
        config.headers['x-portal-token'] = getStorage()
      } else {
        if (getStorage()) {
          config.headers['portal-token'] = getStorage()
        } else if (getStorage('commandTemporaryToken') && !config.headers['no-common-token']){
          config.headers['portal-token'] = getStorage('commandTemporaryToken')
        }
      }
    }
    if (!config.headers['recaptcha-token']) {
      delete config.headers['recaptcha-token']
    }
    return config
  },
  error => {
    console.log("ERROR inside 53:",error);
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const data = response.data || {}
    if (data.code !== 200) {
      if (!response.config.isNotPrompt) {
        if(data.code==403)
        {
        window.history.replaceState(null, document.title, "/403")
        } else 
        Message.error(data.message || 'Service error, please try again')
      }
      return Promise.reject(Object.assign({ status: response.status }, data))
    }
    return Object.assign({}, data, { responseHeaders: response.headers })
  },
  error => {
    try {
    console.log("ERROR inside 71:",response);
      const response = error.response
      const obj = response.data || {}
      obj.status = response.status
      if (response.status === 401) {
        if (!matchWhitelist(location.pathname)) {
          store.dispatch("user/logout")
        }
      } else if (!response.config.isNotPrompt && obj !== 'cancel request') {
        Message.error(obj.message || 'Service error, please try again')
      }
      return Promise.reject(obj)
    } catch(a) {
      console.log("ERROR inside 84:",a);
      return Promise.reject(error)
    }
  }
);

export default service
